import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    key = ''
    key2 = ''
    
    // baseAppUrl = 'http://localhost:49394';
     //baseAppUrl = 'https://localhost:44331'; // local PC
    //baseAppUrl = 'https://alkotek.com/tppcore';
    baseAppUrl = 'https://ddt.theparkpeople.org/tppcore'; // this one Denver
    // baseAppUrl = '../tppcore';
    baseApiUrl = `${this.baseAppUrl}/api/`;
}


